import React from 'react'
import Typography from '@mui/material/Typography'
import { SettingTitleProps } from '../propsTypes'

const SettingTitle = ({ title, alignCenter, maxWidth }: SettingTitleProps) => {
  return (
    <Typography
      variant="h6"
      align={alignCenter ? 'center' : undefined}
      sx={{
        fontWeight: '600',
        fontFamily: 'SpaceGrotesk, sans-serif',
        maxWidth: maxWidth ? maxWidth : undefined,
      }}>
      {title}
    </Typography>
  )
}

export default SettingTitle
